export default "__VITE_ASSET__DLyJ79UN__"